/** Border width tokens, in pixels rather than spacing multipliers. */

export const borderWidth = {
  none: 0,
  thin: 1,
  medium: 2
} as const

export type BorderWidth = keyof typeof borderWidth
